import { render, staticRenderFns } from "./JobRoleEndedTaskItem.vue?vue&type=template&id=b8ec254e&"
import script from "./JobRoleEndedTaskItem.vue?vue&type=script&lang=js&"
export * from "./JobRoleEndedTaskItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports